import React from 'react'
import styled from 'styled-components'

import { ArrowRightIcon } from '../../components/Icons/ArrowRight'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  svg {
    width: 16px;
    min-width: 16px;
    height: 10px;
    margin: 0px 8px;
  }
`

const DestinationWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const FormattedRoute = ({ origin, destination, showCode }) => {
  return (
    <Wrapper>
      <div>
        {origin.name} {showCode ? `(${origin.code})` : ''}
      </div>

      <DestinationWrapper>
        <ArrowRightIcon />

        <div>
          {destination.name} {showCode ? `(${destination.code})` : ''}
        </div>
      </DestinationWrapper>
    </Wrapper>
  )
}
